import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "table table-sm table-bordered" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "text-end" }
const _hoisted_4 = { class: "text-end" }
const _hoisted_5 = { class: "fw-bold" }
const _hoisted_6 = { class: "text-end" }
const _hoisted_7 = { class: "text-end" }

import { onMounted, reactive, watch } from "vue";

//servicos
import * as service from "@/services/BoletosService";
import {  fdata, f2dec,} from "@/utils/funcoes";

interface IProps {
    itens: service.RetornoPorStatusDto[];
    ocorrenciaId: string;
    
}

interface IGrupo {
    id: string;
    descricao: string;
    qtde: number;
    valorUnit: number;
    valorTotal: number;
    valorTotalDoctos: number;
    itens: service.RetornoPorStatusDto[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'RetornoItensStatusProcess',
  props: {
    itens: {},
    ocorrenciaId: {}
  },
  emits: ['filtrar'],
  setup(__props: any, { emit: __emit }) {


//vue
var emit = __emit;

var props = __props;

var controle = reactive({
    ocorrenciaId: props.ocorrenciaId,
    itens: [] as service.RetornoPorStatusDto[],
    model: {} as service.RetornoPorStatusDto,
    processando: false
});

onMounted(() => {
    controle.itens = props.itens;
})

watch(() => props.itens ,(newVal) => {
    controle.itens = newVal;
    controle.model = {} as service.RetornoPorStatusDto;
});

watch(() => props.ocorrenciaId ,(newVal) => {
    controle.ocorrenciaId = newVal;
});

function filtrar(item: service.RetornoPorStatusDto){
    controle.model = item;
    emit('filtrar', item);
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "col-md-12 col-12 fs-6 fw-bold" }, " Resumo por Status ", -1)),
    _createElementVNode("table", _hoisted_1, [
      _cache[1] || (_cache[1] = _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("th", null, "Descrição"),
          _createElementVNode("th", { class: "text-end" }, "Qtde"),
          _createElementVNode("th", { class: "text-end" }, "Total R$")
        ])
      ], -1)),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controle).itens, (item, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
            (_unref(controle).ocorrenciaId == item.ocorrenciaId)
              ? (_openBlock(), _createElementBlock("tr", {
                  key: 0,
                  onClick: ($event: any) => (filtrar(item)),
                  class: _normalizeClass(item.statusProcessamento == _unref(controle).model.statusProcessamento ? 'table-active' : ''),
                  style: {"cursor":"pointer"}
                }, [
                  _createElementVNode("td", null, _toDisplayString(item.statusProcessamento), 1),
                  _createElementVNode("td", _hoisted_3, _toDisplayString(item.qtde), 1),
                  _createElementVNode("td", _hoisted_4, _toDisplayString(_unref(f2dec)(item.valorDocumento)), 1)
                ], 10, _hoisted_2))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ]),
      _createElementVNode("tfoot", null, [
        _createElementVNode("tr", _hoisted_5, [
          _cache[0] || (_cache[0] = _createElementVNode("td", null, "Total", -1)),
          _createElementVNode("td", _hoisted_6, _toDisplayString(_unref(controle).itens.reduce((acc, item) => acc + item.qtde, 0)), 1),
          _createElementVNode("td", _hoisted_7, _toDisplayString(_unref(f2dec)(_unref(controle).itens.reduce((acc, item) => acc + item.valorDocumento, 0))), 1)
        ])
      ])
    ])
  ], 64))
}
}

})